import { Component, OnInit } from '@angular/core';
import { Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: '',
  template: '',
})
export class AgentNomineeHandlerComponent extends BaseComponent<AgentService> {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddAgentNomineeDetails(event) {
    this.service.addAgentNomineeDetails();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  protected age_change(item: FieldItem) {
    if (item.model.age <= 18) {
      item.model.appointeeName = null;
    }
  }
}
